module.exports = __webpack_public_path__ + "img/circuit.1acba230.png";